module.exports = __webpack_public_path__ + "img/partners3.bc7c263c.jpg";